/* eslint-disable react/display-name */
import { Table } from "antd";
import Layout from "../../Layout";
import content from "./content";
import "antd/dist/antd.css";
import urlRegex from "url-regex";
const TGreen = "rgba(1,163,134,1)";

const TermsOfServicePage = (): JSX.Element => {
  return (
    <Layout hideHeader={true}>
      <div
        style={{
          maxWidth: "80vw",
          alignSelf: "center",
          marginTop: 120,
          marginBottom: 20,
        }}
      >
        {content.map((item, itemIndex) => (
          <div style={{ marginTop: 20 }} key={itemIndex}>
            <div>
              <p>{itemIndex + 1 + ". " + item.title}</p>
            </div>

            {item.sections.map((section, sectionIndex) => {
              // eslint-disable-next-line @typescript-eslint/no-var-requires

              if (section.description) {
                return (
                  <div>
                    <div style={{ marginTop: 7, marginLeft: 20 }}>
                      {itemIndex +
                        1 +
                        "." +
                        (sectionIndex + 1) +
                        ". " +
                        section.description.replace(
                          urlRegex({ strict: true }),
                          (url) =>
                            '<a style="color: ' +
                            TGreen +
                            '" href="' +
                            url +
                            '">' +
                            url +
                            "</a>"
                        )}
                    </div>
                    {section.subsection ? (
                      section.subsection.map((subSection, subSectionIndex) => {
                        if (section.description && subSection) {
                          return (
                            <div
                              style={{ marginTop: 7, marginLeft: 40 }}
                              dangerouslySetInnerHTML={{
                                __html:
                                  "<span>" +
                                  String.fromCharCode(97 + subSectionIndex) +
                                  ") " +
                                  (subSection.description?.replace(
                                    urlRegex({
                                      strict: true,
                                    }),
                                    (url) =>
                                      '<a style="color: ' +
                                      TGreen +
                                      '" href="' +
                                      url +
                                      '">' +
                                      url +
                                      "</a>"
                                  ) +
                                    "</span>"),
                              }}
                            />
                          );
                        } else if (section.subsection) {
                          return (
                            <div
                              style={{ marginTop: 7, marginLeft: 20 }}
                              dangerouslySetInnerHTML={{
                                __html:
                                  "<span>" +
                                  itemIndex +
                                  1 +
                                  "." +
                                  (sectionIndex + 1) +
                                  ". " +
                                  (section && section.description
                                    ? section.description.replace(
                                        urlRegex({
                                          strict: true,
                                        }),
                                        (url) =>
                                          '<a style="color: ' +
                                          TGreen +
                                          '" href="' +
                                          url +
                                          '">' +
                                          url +
                                          "</a>"
                                      )
                                    : "") +
                                  "</span>",
                              }}
                            />
                          );
                        }
                        return null;
                      })
                    ) : (
                      <div />
                    )}
                  </div>
                );
              } else if (section.table) {
                return (
                  <div style={{ margin: 30 }}>
                    <Table
                      dataSource={section.table}
                      columns={[
                        {
                          title: "Keyword",
                          dataIndex: "keyword",
                          key: "keyword",
                        },
                        {
                          title: "Description",
                          dataIndex: "description",
                          key: "description",
                          render: (value) => (
                            <div
                              dangerouslySetInnerHTML={{
                                __html:
                                  "<span>" +
                                  (value
                                    ? value.replace(
                                        urlRegex({
                                          strict: true,
                                        }),
                                        (url: string) =>
                                          '<a style="color: ' +
                                          TGreen +
                                          '" href="' +
                                          url +
                                          '">' +
                                          url +
                                          "</a>"
                                      )
                                    : "") +
                                  "</span>",
                              }}
                            />
                          ),
                        },
                      ]}
                      pagination={false}
                    />
                  </div>
                );
              }
              return null;
            })}
          </div>
        ))}
      </div>
    </Layout>
  );
};

export default TermsOfServicePage;
